import { Collapse } from "bootstrap";

const ActiveLeafClassName = ".simple-navigation-active-leaf";
const CollapseClassName = ".collapse";
const SidebarHiddenClassName = "sidebar-hidden";
const SidebarStateKey = "SidebarHidden";

const saveSidebarState = (hidden: boolean): void => {
  localStorage.setItem(SidebarStateKey, hidden);
};

const showSidebar = (sidebar: HTMLBodyElement): void => {
  sidebar.classList.remove(SidebarHiddenClassName);
  saveSidebarState(false);
};

const hideSidebar = (sidebar: HTMLBodyElement): void => {
  sidebar.classList.add(SidebarHiddenClassName);
  saveSidebarState(true);
};

export const collapseActiveNavigation = (): void => {
  const parents = $(ActiveLeafClassName).parents(CollapseClassName).toArray();

  parents.forEach((parent) => {
    const collapse = Collapse.getOrCreateInstance(parent);
    collapse.show();
  });
};

export const loadSidebarState = (sidebar: HTMLBodyElement): void => {
  const sidebarHidden = localStorage.getItem(SidebarStateKey);

  if (sidebarHidden && sidebarHidden === "true") {
    hideSidebar(sidebar);
  } else {
    showSidebar(sidebar);
  }
};

export const toggleSidebar = (sidebar: HTMLBodyElement, event: Event): void => {
  event.preventDefault();

  if (sidebar.classList.contains(SidebarHiddenClassName)) {
    showSidebar(sidebar);
  } else {
    hideSidebar(sidebar);
  }
};
